angular.module('v3sWbtPlayerApp').controller('v3sToolTreeCtrl', ["$scope", "$aside", "v3sServiceFinder", "v3sI18nService", "wbt", function ($scope, $aside, v3sServiceFinder, v3sI18nService, wbt) {
    var v3sAsideService = v3sServiceFinder.get("v3sAsideService");
    var v3sToolsService = v3sServiceFinder.get("v3sToolsService");

    if (v3sToolsService) {
        var tree;
        $scope.item = null;
        $scope.wbt = wbt;

        v3sToolsService.onPageChanged($scope, function (page) {
            $scope.item = page;
        });

        tree = $aside({ scope: $scope, title: v3sI18nService.getText("dialogs.tree.title"), templateUrl: 'app/js/tools/aside.tpl.html', contentTemplate: 'app/js/tools/tree/tree.tpl.html', show: false, placement: 'left' });

        var showTree = function showTree(page) {
            $scope.item = page;
            tree.$promise.then(function () {

                if (tree.$isShown) {
                    tree.hide();
                } else {
                    tree.show();

                    if (v3sAsideService) v3sAsideService.makeDraggable(tree, true);
                }
            });
        };

        v3sToolsService.onToggleTree($scope, showTree);
        v3sToolsService.onHideTree($scope, tree.hide);
    }
}]);
